import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
export var isMobile = function isMobile() {
  return typeof window !== 'undefined' ? window.innerWidth < 500 : false;
};
export var showHint = function showHint(props, state) {
  return Boolean(props.searchHint) && Boolean(props.searchAction) && !state.search.length && !state.searchResults.length;
};